import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NotificationService, NotificationType } from 'src/app/notification/notification/notification.service';
import { environment } from 'src/environments/environment';

interface Language {
  code: string;
  name: string;
}

@Component({
  selector: 'app-translate-pdf',
  templateUrl: './translate-pdf.component.html',
})
export class TranslatePdfComponent implements OnInit {
  uploadedFile: File | null = null;
  selectedLanguage: string = '';
  isSubmitting = false;

  languages: Language[] = [
    { code: 'hi', name: 'Hindi' },
    { code: 'mr', name: 'Marathi' },
    { code: 'gu', name: 'Gujarati' },
    { code: 'ml', name: 'Malayalam' },
    { code: 'en', name: 'English' },
    { code: 'pa', name: 'Punjabi' },
    { code: 'bn', name: 'Bengali' },
    { code: 'or', name: 'Odia' },
    { code: 'as', name: 'Assamese' },
    {code: 'ta', name: 'Tamil'},
    {code: 'te', name: 'Telugu'},
    {code: 'kn', name: 'Kannada'},
  ];

  constructor(
    private _http: HttpClient,
    private _notificationService: NotificationService
  ) {}

  ngOnInit(): void {}

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      if (file.type === 'application/pdf') {
        this.uploadedFile = file;
      } else {
        this._notificationService.showNotification('Please upload a PDF file.', NotificationType.ERROR);
        input.value = '';
      }
    }
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (file.type === 'application/pdf') {
        this.uploadedFile = file;
      } else {
        this._notificationService.showNotification('Please upload a PDF file.', NotificationType.ERROR);
      }
    }
  }

  removeFile(): void {
    this.uploadedFile = null;
  }

  onSubmit(): void {
    if (!this.uploadedFile) {
      this._notificationService.showNotification('Please upload a PDF file.', NotificationType.ERROR);
      return;
    }

    if (!this.selectedLanguage) {
      this._notificationService.showNotification('Please select a language.', NotificationType.ERROR);
      return;
    }

    this.isSubmitting = true;

    const formData = new FormData();
    formData.append('file', this.uploadedFile);

    const url = `${environment.serverUrl}/docs-translator/translate?targetLanguage=${this.selectedLanguage}&sourceLanguage=en`;

    this._http.post(url, formData, { responseType: 'text' }).subscribe({
      next: (downloadUrl: string) => {
        this._notificationService.showNotification('PDF translated successfully! Downloading...', NotificationType.INFO);
        
        // Force download by fetching the file and triggering download
        this.downloadFile(downloadUrl, `translated_${this.uploadedFile!.name}`);
        
        // Reset form
        this.uploadedFile = null;
        this.selectedLanguage = '';
        this.isSubmitting = false;
      },
      error: (error) => {
        console.error('Translation failed:', error);
        this.isSubmitting = false;
        this._notificationService.showNotification('Translation failed. Please try again.', NotificationType.ERROR);
      }
    });
  }

  private downloadFile(url: string, filename: string): void {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      })
      .catch(error => {
        console.error('Download failed:', error);
        // Fallback: open in new window
        window.open(url, '_blank');
      });
  }
}
